var _polyline, _rect, _line, _polyline2, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    enableBackground: "new 0 0 28 28",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#4D4BB6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    points: "14.387,25.971 2.417,25.971 2.417,2.03  26.357,2.03 26.357,14 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.397,
    y: 2.03,
    fill: "none",
    stroke: "#4D4BB6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    width: 7.98,
    height: 7.98
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4D4BB6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    x1: 10.397,
    y1: 6.818,
    x2: 18.377,
    y2: 6.818
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#4D4BB6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    points: "16.781,19.587 20.771,15.597  24.762,19.587 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4D4BB6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    x1: 20.771,
    y1: 15.597,
    x2: 20.771,
    y2: 25.174
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.985eee39e214a83cf0c897c9ff4fccef.svg";
export { ForwardRef as ReactComponent };